import type { SVGProps } from 'react'

/**
 * micro·hub — фирменный знак (asymmetric hub: 3 спутника вокруг центрального узла).
 * Единственная точка правды — не хардкодить SVG-логотип где-либо ещё.
 */
export function BrandMark({ size = 32, ...rest }: { size?: number } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="micro-hub"
      {...rest}
    >
      <rect x="2" y="2" width="96" height="96" rx="20" fill="#2563eb" />
      <line x1="50" y1="50" x2="22" y2="22" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" />
      <line x1="50" y1="50" x2="78" y2="30" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" />
      <line x1="50" y1="50" x2="68" y2="80" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" />
      <circle cx="22" cy="22" r="7" fill="#fff" />
      <circle cx="78" cy="30" r="7" fill="#fff" />
      <circle cx="68" cy="80" r="7" fill="#fff" />
      <circle cx="50" cy="50" r="13" fill="#fff" />
      <circle cx="50" cy="50" r="6" fill="#2563eb" />
    </svg>
  )
}
